interface MyObject {
  [key: string]: any
}

export const removeUndefinedProperties = (obj: MyObject): MyObject => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== '' && value !== null)
  )
}
